// 覚醒王が歩いて下がる時の絵 (2026-11-02 朝の問2)。11-03 作者の答え「振り向いて歩く」で turn が配布版の既定。前の絵 (向きはそのまま) は DEV `?awokenBackWalk=now`。
//   見つけた所: 6戦の撮影 (docs/research/2026-11-02-six-fights-sweep.md) で、覚醒王が左を向いたまま右へ下がる間 (懐では噛まない・
//   顔を見せる間合いの後ろ歩き = src/awoken_spacing_choice.ts の walk で dir が相手から離れる向き)、前へ歩く2枚がそのまま回り、
//   足が後ろへ滑って見えた。
//   'turn' = 下がる間だけ絵を反転して「振り向いて歩く」。本体の向き (boss.facing)・位置・間合い・当たりは変えない (絵だけ)。
//   「歩きの絵を逆に回す」案は作っていない: 覚醒王の歩きは walk_passing ↔ walk_reach の2枚の切り替えなので、逆に回しても並びが同じになる。
import type { Boss } from './types'
import { isAwokenSpacingWalk } from './awoken_spacing_choice'

export type AwokenBackWalkMode = 'now' | 'turn'
let mode: AwokenBackWalkMode = 'turn'
/** DEV の切り替え (game.ts)。'now' だけが前の絵。 */
export function setAwokenBackWalk(v: string | null): AwokenBackWalkMode {
  mode = import.meta.env.DEV && v === 'now' ? 'now' : 'turn'
  return mode
}

/** 覚醒王が相手から離れる向きへ歩いている最中か (向きと進む向きが逆)。 */
export function isAwokenBackWalk(boss: Boss): boolean {
  if (boss.id !== 'crowned-king-awoken' || !isAwokenSpacingWalk(boss)) return false
  const facingDir = boss.facing === 'left' ? -1 : 1
  return boss.spacing!.dir !== facingDir
}

/** 絵を描く時の向き。比較版 'turn' で下がっている間だけ反対を向く。 */
export function awokenBackWalkDrawFacing(boss: Boss): Boss['facing'] {
  if (mode !== 'turn' || !isAwokenBackWalk(boss)) return boss.facing
  return boss.facing === 'left' ? 'right' : 'left'
}
